import { z } from 'zod';

export const oneOffPaymentNoticePostRequestSchema = z.object({ amount: z.string(), reference: z.string() });
